export default __webpack_public_path__ + "static/autism-australia-logo-7ada5f302834b10443586f0b6a551cd0.svg";